module.exports = __webpack_public_path__ + "static/media/excel.2d2f7115.svg";